import { useState, useEffect } from "react";
import { a as isWindowDefined } from "./index-CzdAPYVv.js";
import { r as TEST_MODE_QUERY_PARAM } from "./index-B6R21tiH.js";
const useIsTestMode = () => {
  const [isTestMode, setIsTestMode] = useState(false);
  useEffect(() => {
    if (!isWindowDefined()) return;
    const windowParams = new URL(window.location.href).searchParams;
    setIsTestMode(windowParams.has(TEST_MODE_QUERY_PARAM) && Boolean(windowParams.get(TEST_MODE_QUERY_PARAM)));
  }, []);
  return isTestMode;
};
export {
  useIsTestMode as u
};
//# sourceMappingURL=useIsTestMode-CiXhde60.js.map
